import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const ProductPage = () => {

  const productSectionStyle = {
    display: 'grid',
    gridTemplateColumns: '1fr 1.2fr',
    gap: '40px',
    alignItems: 'center',
  };

  const headingStyle = {
    fontSize: '2.2rem',
    lineHeight: '1.3',
    color: '#222',
    fontWeight: '600',
  };
  

  const imgHover = {
    transition: 'transform 0.4s ease, box-shadow 0.4s ease',
    width: '100%',
    height: 'auto',
  };

  const imgHoverContainer = {
    overflow: 'hidden',
    borderRadius: '10px',
  };

  /* 🔥 Responsive Overrides using inline CSS media-query logic */
 const responsiveStyle = `
  @media (max-width: 992px) {
    .resp-section, .resp-flex {
      display: flex !important;
      flex-direction: column !important; /* Image upar, text neeche */
      text-align: center !important;
    }

    .resp-section > div, .resp-flex > div {
      width: 100% !important;       /* Full width image aur text */
      margin-bottom: 20px !important; /* Image aur text ke beech gap */
    }

    .resp-img-full {
      width: 100% !important;       /* Image full width ho jaye */
      height: auto !important;      /* Aspect ratio maintain rahe */
      object-fit: cover !important; /* Crop karne par proper fit */
    }

    .resp-gap {
      gap: 20px !important;         /* Flex ke beech spacing */
    }
  }
`;

  return (
    <div id="main-wrapper">
      <style>{responsiveStyle}</style>

      <Header />
      <div id="content" role="main">

        {/* ============ HERO SECTION ============= */}
        <section
          className="hero-wrap"
          style={{
            position: "relative",
            overflow: "hidden",
            minHeight: "50vh",
            display: "flex",
            alignItems: "center",
            backgroundImage: "url('/images/projects/sh.jpg')",
            backgroundSize: "cover",
            backgroundPosition: "center center",
          }}
        >
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(0,0,0,0.5)",
              zIndex: 1,
            }}
          />

          <div
            className="container"
            style={{ position: "relative", zIndex: 2, padding: "70px 0" }}
          >
            <div className="row">
              <div className="col-12 text-center text-white">
                <h1 style={{ color: 'white' }}>Smart IT, IoT & Automation Solutions</h1>
                <p className="lead text-white-100 mb-0">
                  Complete industrial solutions for machine integration, IoT connectivity,
                  automation, analytics, and robotics.
                </p>
              </div>
            </div>
          </div>
        </section>



{/* ============ SECTION 1 ============= */}
<section className="section bg-light" style={{ padding: '80px 0' }}>
  <div className="container">
    <div className="resp-flex resp-gap" style={{
      display: 'flex',
      gap: '40px',
      alignItems: 'center',
      justifyContent: 'space-between',
      flexDirection: 'row-reverse' // IMAGE RIGHT, TEXT LEFT
    }}>
      {/* IMAGE */}
      <div style={{ ...imgHoverContainer, width: '50%', maxWidth: '570px' }} className="resp-center">
        <img
          src="/images/projects/Machine-inte.png"
          alt="Integration"
          className="img-fluid rounded shadow resp-img-full"
          style={{
            ...imgHover,
            height: "300px",
            width: "100%",
            objectFit: "cover",
          }}
          onMouseEnter={(e) => (e.target.style.transform = "scale(1.05)")}
          onMouseLeave={(e) => (e.target.style.transform = "scale(1)")}
        />
      </div>

      {/* TEXT */}
      <div className="resp-center" style={{ width: '50%' }}>
        <h2 style={headingStyle}>Machine Integration & M2M Connectivity</h2>
        <p className="text-4 mb-3">
          Our machine-to-machine (M2M) technologies enable seamless communication between industrial equipment, controllers, and enterprise systems. We support multi-protocol integration such as Modbus, OPC, MQTT, and TCP/IP.Automating data flow and remote monitoring improves efficiency and reduces downtime.
        </p>
        {/* <p className="text-3 mb-3">
          We support multi-protocol integration such as Modbus, OPC, MQTT, and TCP/IP.
        </p>
        <p className="text-3 mb-3">
          Automating data flow and remote monitoring improves efficiency and reduces downtime.
        </p> */}
      </div>
    </div>
  </div>
</section>

{/* ============ SECTION 2 ============= */}
<section className="section bg-light" style={{ padding: '80px 0' }}>
  <div className="container">
    <div className="resp-flex resp-gap" style={{
      display: 'flex',
      gap: '40px',
      alignItems: 'center',
      justifyContent: 'space-between',
      flexDirection: 'row' // IMAGE LEFT, TEXT RIGHT
    }}>
      {/* IMAGE */}
      <div style={{ ...imgHoverContainer, width: '50%', maxWidth: '570px' }} className="resp-center">
        <img
          src="/images/projects/Industrial.png"
          alt="IoT"
          className="img-fluid rounded shadow resp-img-full"
          style={{
            ...imgHover,
            height: "300px",
            width: "100%",
            objectFit: "cover",
          }}
          onMouseEnter={(e) => (e.target.style.transform = "scale(1.05)")}
          onMouseLeave={(e) => (e.target.style.transform = "scale(1)")}
        />
      </div>

      {/* TEXT */}
      <div className="resp-center" style={{ width: '50%' }}>
        <h2 style={headingStyle}>Industrial IoT & Digitalization Solutions</h2>
        <p className="text-4 mb-3">
          Our IoT platform brings machines, sensors, and controllers onto one ecosystem. We integrate PLCs, CNC, robotics using OPC-UA, MQTT, Modbus & REST APIs.Unified dashboards provide alerts, KPIs, machine health & predictive insights.
        </p>
        {/* <p className="text-3 mb-3">
          We integrate PLCs, CNC, robotics using OPC-UA, MQTT, Modbus & REST APIs.
        </p>
        <p className="text-3 mb-3">
          Unified dashboards provide alerts, KPIs, machine health & predictive insights.
        </p> */}
      </div>
    </div>
  </div>
</section>

{/* ============ SECTION 3 ============= */}
<section className="section bg-light" style={{ padding: '80px 0' }}>
  <div className="container">
    <div className="resp-flex resp-gap" style={{
      display: 'flex',
      gap: '40px',
      alignItems: 'center',
      justifyContent: 'space-between',
      flexDirection: 'row-reverse' // IMAGE RIGHT, TEXT LEFT
    }}>
      {/* IMAGE */}
      <div style={{ ...imgHoverContainer, width: '50%', maxWidth: '570px' }} className="resp-center">
        <img
          src="/images/projects/Real-Time.png"
          alt="Real-Time"
          className="img-fluid rounded shadow resp-img-full"
          style={{
            ...imgHover,
            height: "300px",
            width: "100%",
            objectFit: "cover",
          }}
          onMouseEnter={(e) => (e.target.style.transform = "scale(1.05)")}
          onMouseLeave={(e) => (e.target.style.transform = "scale(1)")}
        />
      </div>

      {/* TEXT */}
      <div className="resp-center" style={{ width: '50%' }}>
        <h2 style={headingStyle}>Real-Time Data Acquisition & Analytics</h2>
        <p className="text-4 mb-3">
          We provide real-time machine data acquisition with advanced analytics , Supports predictive maintenance, anomaly detection & performance optimization. SCADA dashboards enhance productivity and reduce downtime.
        </p>
        {/* <p className="text-3 mb-3">
          Supports predictive maintenance, anomaly detection & performance optimization.
        </p>
        <p className="text-3 mb-3">
          SCADA dashboards enhance productivity and reduce downtime.
        </p> */}
      </div>
    </div>
  </div>
</section>

{/* ============ SECTION 4 ============= */}
<section className="section bg-light" style={{ padding: '80px 0' }}>
  <div className="container">
    <div className="resp-flex resp-gap" style={{
      display: 'flex',
      gap: '40px',
      alignItems: 'center',
      justifyContent: 'space-between',
      flexDirection: 'row' // IMAGE LEFT, TEXT RIGHT
    }}>
      {/* IMAGE */}
      <div style={{ ...imgHoverContainer, width: '50%', maxWidth: '570px' }} className="resp-center">
        <img
          src="/images/projects/Auto.png"
          alt="Automation"
          className="img-fluid rounded shadow resp-img-full"
          style={{
            ...imgHover,
            height: "300px",
            width: "100%",
            objectFit: "cover",
          }}
          onMouseEnter={(e) => (e.target.style.transform = "scale(1.05)")}
          onMouseLeave={(e) => (e.target.style.transform = "scale(1)")}
        />
      </div>

      {/* TEXT */}
      <div className="resp-center" style={{ width: '50%' }}>
        <h2 style={headingStyle}>Automation & Control Engineering</h2>
        <p className="text-4 mb-3">
          We design PLC, HMI & SCADA-based control systems. Supports high-speed production, fault detection & safety interlocks. Ensuring high precision, safety, and reliable automation.
        </p>
        {/* <p className="text-3 mb-3">
          Supports high-speed production, fault detection & safety interlocks.
        </p>
        <p className="text-3 mb-3">
          Ensures high precision, safety, and reliable automation.
        </p> */}
      </div>
    </div>
  </div>
</section>

{/* ============ SECTION 5 ============= */}
<section className="section bg-light" style={{ padding: '80px 0' }}>
  <div className="container">
    <div className="resp-flex resp-gap" style={{
      display: 'flex',
      gap: '40px',
      alignItems: 'center',
      justifyContent: 'space-between',
      flexDirection: 'row-reverse' // IMAGE RIGHT, TEXT LEFT
    }}>
      {/* IMAGE */}
      <div style={{ ...imgHoverContainer, width: '50%', maxWidth: '570px' }} className="resp-center">
        <img
          src="/images/projects/Control.png"
          alt="Control Panel"
          className="img-fluid rounded shadow resp-img-full"
          style={{
            ...imgHover,
            height: "300px",
            width: "100%",
            objectFit: "cover",
          }}
          onMouseEnter={(e) => (e.target.style.transform = "scale(1.05)")}
          onMouseLeave={(e) => (e.target.style.transform = "scale(1)")}
        />
      </div>

      {/* TEXT */}
      <div className="resp-center" style={{ width: '50%' }}>
        <h2 style={headingStyle}>Control Panel Design & System Upgrades</h2>
        <p className="text-4 mb-3">
          We design custom control panels for reliable machine operations. We upgrade PLCs, panel wiring, and integrate SCADA/IoT.Enables safer, faster, and more efficient industrial operations.
        </p>
        {/* <p className="text-3 mb-3">
          We upgrade PLCs, panel wiring, and integrate SCADA/IoT.
        </p>
        <p className="text-3 mb-3">
          Enables safer, faster, and more efficient industrial operations.
        </p> */}
      </div>
    </div>
  </div>
</section>

{/* ============ SECTION 6 ============= */}
<section className="section bg-light" style={{ padding: '80px 0' }}>
  <div className="container">
    <div className="resp-flex resp-gap" style={{
      display: 'flex',
      gap: '40px',
      alignItems: 'center',
      justifyContent: 'space-between',
      flexDirection: 'row' // IMAGE LEFT, TEXT RIGHT
    }}>
      {/* IMAGE */}
      <div style={{ ...imgHoverContainer, width: '50%', maxWidth: '570px' }} className="resp-center">
        <img
          src="/images/projects/Energy.png"
          alt="Energy"
          className="img-fluid rounded shadow resp-img-full"
          style={{
            ...imgHover,
            height: "300px",
            width: "100%",
            objectFit: "cover",
          }}
          onMouseEnter={(e) => (e.target.style.transform = "scale(1.05)")}
          onMouseLeave={(e) => (e.target.style.transform = "scale(1)")}
        />
      </div>

      {/* TEXT */}
      <div className="resp-center" style={{ width: '50%' }}>
        <h2 style={headingStyle}>Energy & Utility Monitoring Systems</h2>
        <p className="text-4 mb-3">
          We monitor power, water, air, gas, and steam usage in real time. Helps industries reduce wastage and increase efficiency. IoT dashboards send predictive alerts and optimize usage.
        </p>
        {/* <p className="text-3 mb-3">
          Helps industries reduce wastage and increase efficiency.
        </p>
        <p className="text-3 mb-3">
          IoT dashboards send predictive alerts and optimize usage.
        </p> */}
      </div>
    </div>
  </div>
</section>

{/* ============ SECTION 7 ============= */}
<section className="section bg-light" style={{ padding: '80px 0' }}>
  <div className="container">
    <div className="resp-flex resp-gap" style={{
      display: 'flex',
      gap: '40px',
      alignItems: 'center',
      justifyContent: 'space-between',
      flexDirection: 'row-reverse' // IMAGE RIGHT, TEXT LEFT
    }}>
      {/* IMAGE */}
      <div style={{ ...imgHoverContainer, width: '50%', maxWidth: '570px' }} className="resp-center">
        <img
          src="/images/projects/Robotics.png"
          alt="Robotics"
          className="img-fluid rounded shadow resp-img-full"
          style={{
            ...imgHover,
            height: "300px",
            width: "100%",
            objectFit: "cover",
          }}
          onMouseEnter={(e) => (e.target.style.transform = "scale(1.05)")}
          onMouseLeave={(e) => (e.target.style.transform = "scale(1)")}
        />
      </div>

      {/* TEXT */}
      <div className="resp-center" style={{ width: '50%' }}>
        <h2 style={headingStyle}>Robotics & Advanced Automation Integration</h2>
        <p className="text-4 mb-3">
          We integrate robotics for assembly, handling, and inspection.  Our systems use AI, machine vision & precision actuators. Enhances accuracy, safety, and scalable automation.
        </p>
        {/* <p className="text-3 mb-3">
          Our systems use AI, machine vision & precision actuators.
        </p>
        <p className="text-3 mb-3">
          Enhances accuracy, safety, and scalable automation.
        </p> */}
      </div>
    </div>
  </div>
</section>

        {/* ============ CTA SECTION ============= */}
        <section
          className="section bg-primary text-white"
          style={{
            backgroundImage: "linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6)), url('/images/projects/product-footer.png')",
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        >
          <div className="container">
            <div className="row align-items-center">

              <div className="col-lg-8 mb-4 mb-lg-0">
                <h1 style={{ fontSize: '2.2rem', color: "white" }}>
                  Ready for Digital Transformation?
                </h1>
                <p className="lead mb-0">Request a personalized demo today.</p>
              </div>

              <div className="col-lg-4 text-lg-right resp-center">
                <a href="/contact" className="btn btn-light btn-lg rounded-pill">
                  Request a Demo
                </a>
              </div>

            </div>
          </div>
        </section>

      </div>

      <Footer />
    </div>
  );
};

export default ProductPage;
